import { useGLTF } from '@react-three/drei'
import { useEffect } from 'react'

import { useResourceUrl } from '@salsita-ai/platform-project-sdk/react'

export const usePreloadGltf = (files: string[], delay: number = 0) => {
  const { getResourceUrl } = useResourceUrl()
  useEffect(() => {
    const timeout = setTimeout(() => {
      files
        .map(file => getResourceUrl(file))
        .forEach(url => {
          useGLTF.preload(url)
        })
    }, delay)

    return () => {
      clearTimeout(timeout)
    }
  }, [files, getResourceUrl, delay])
}
